<template>
  <!-- Implementa la pagina di login ai servizi BitQ. Usiamo un componente perchè in base                -->
  <!-- al parametro "cat" numerico che viene passato in POST insieme ai dati criptati, l'utente          -->
  <!-- può essere rediretto sulle varie vetrine BitQ. Se non viene passata la prop "showcase_id" a allora-->
  <!-- il parametro cat che è opzionale, non viene inviato.                                              -->
  <div>
    <b-card :title="service_title" class="mr-1 ml-1">
        <b-row>
        <b-col class="alert alert-warning" role="alert">
            <h5><b-icon icon="exclamation-triangle"></b-icon> IMPORTANTE:</h5>
            <p>Si rende noto che nel rispetto degli artt. 51 e 100 del Testo Unico Imposte sui Redditi, il beneficiario del Piano Welfare può effettuare acquisti tramite la piattaforma web nella sezione "{{service_title}}":</p>
            <p>- solo per le finalità indicate al comma 1 dell'art. 100 (educazione, istruzione, ricreazione, assistenza sociale e sanitaria o culto);</p>
            <p>- solo per sé o per i familiari indicati nell'art.433 del Codice Civile vigente, richiamato dall'art. 12 del Testo Unico Imposte sui Redditi.</p>
        </b-col>
        </b-row>
        <b-row>
        <b-col>
            <p>Di seguito l'elenco dei soggetti che, oltre al titolare del piano welfare, possono beneficiare dei servizi acquistati:</p>
            <ul>
            <li>il coniuge (non legalmente ed effettivamente separato)</li>
            <li>i figli (legittimi o legittimati o naturali o adottivi) anche adottivi, e, in loro mancanza, i discendenti prossimi (anche naturali)</li>
            <li>i genitori e, in loro mancanza, gli ascendenti prossimo, anche naturali; gli adottanti</li>
            <li>il partner nelle unioni civili (Legge 20 maggio 2016, n.76)</li>
            <!-- <li>i generi e le nuore</li>
            <li>il suocero e la suocera</li>
            <li>i fratelli e le sorelle germani o unilaterali, con precedenza dei germani sugli unilaterali</li> -->
            </ul>
        </b-col>
        </b-row>
        <b-row>
        <b-col>
            <!-- Per il form usiamo gli attributi "classici" e non effettuamo il submit con axios perchè ci serve il target "blank" per il redirect -->
            <!-- Il campo di input non lo prendiamo da bootstrap vue perchè hidden non è supportato -->
            <b-form target="_blank"
                ref="sso_form"
                method="POST"
                :action="login_url">
                <!-- Parametro opzionale per la visualizzazione di una specifica vetrina -->
                <!-- viene inviato solo se la prop è passata altrimenti si atterra sulla -->
                <!-- pagina di default -->
                <input v-if="showcase_id" type="hidden" name="cat" :value="showcase_id">
                <input type="hidden" name="d" :value="user_data">
                <b-form-group id="group-ok-condizioni">
                    <b-form-checkbox
                    id="ok-condizioni"
                    name="ok-condizioni"
                    :value="true"
                    :unchecked-value="false"
                    v-model="conditions_checkbox"
                    required>
                    <span class="font-italic">Il/la sottoscritto/a dichiara, sotto la propria responsabilità, che i dati relativi ai familiari che verranno inseriti sulla piattaforma sono veritieri e si impegna a modificarli qualora avvenissero vicende modificative di tali dati. In caso di verifica di nominativo non appartenente all’elenco di cui sopra autorizzo Welfarebit srl ad emettere nei miei confronti regolare fattura per i servizi acquistati.</span>
                    </b-form-checkbox>
                </b-form-group>
                <!-- Il submit viene effettuato dalla funzione execute_sso la quale fa poi comparire la pagina di redirect alla home -->
                <!-- non possiamo contrasegnare il pulsante come submit perchè se usiamo anche l'evento click questo impedisce il submit -->
                <!-- stesso evitando l'apertura della pagina di fano al centro. -->
                <b-button v-if="show_submit_btn" variant="primary" @click="execute_sso">Accedi al portale {{service_title}}</b-button>
            </b-form>
        </b-col>
        </b-row>
        <!-- Uno slot per del contenuto addizionale sotto al form -->
        <slot name="form-footer"></slot>
    </b-card>
  </div>
</template>

<script>
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'

export default {
  name: 'BitQLoginPage',
  data () {
    return {

      // Checkbox di conferma delle condizioni
      conditions_checkbox: false,

      // Url di login e dati utente cifrati presi dal backend
      login_url: null,
      user_data: null
    }
  },
  computed : {
    /**
     * Visualizza o meno il bottone di invio del form sulla base del valore della checkbox.
     */
    show_submit_btn : function () {
      return  this.conditions_checkbox === true ? true : false;
    }
  },
  created : function () {
    /* Costruisco la stringa criptata con i dati utente e l'url di login */
    axios.post( apiUrl.welfareapi.create_acq_bitq_login )
    .then( ( response ) => {
      this.user_data = response.data.enc_data;
      this.login_url = response.data.login_url;
    })
    .catch( ( error ) => {
      generalLib.backend_error_message_box( this, error.response.data );
    });
  },
  methods : {
    /**
     * Invia i dati del form per eseguire l'SSO poi visualizza la pagina
     * di redirect di cortesia la quale ci riporta infine alla home.
     */
    execute_sso : function () {
      // Prendiamo il form ed invochiamo manualmente l'evento submit
      // per inviare i dati.
      let form = this.$refs.sso_form;
      form.submit();
      this.$router.replace( { name : 'conv-redirect', params:  { page_title : this.service_title } } );
    }
  },
  props : {
    /**
     * Titolo del servizio BitQ richiesto
    */
    service_title: {
        type: String,
        required: true
    },
    /**
     * Id della vetrina BitQ da mostrare, si tratta
     * del parametro "cat" da inviare in POST nel momento
     * dell'SSO insieme ai dati criptati.
     * Il parametro è opzionale, se la prop non viene fornita
     * il parametro non viene inviato.
     */
    showcase_id: {
        type: Number,
        default: null
    }
  }
}
</script>

<style scoped></style>